import React from 'react'
import { intl } from 'lang/intl'
import { FormattedMessage } from 'react-intl'

import Chyron, { ChyronSize } from './chyron'

import './speaker-info-chyron.scss'

interface SpeakerInfoChyronProps {
  name: string
  title?: string
  avatarUrl?: string
  bio?: string
  company?: string
}

const SpeakerInfoChyron = ({
  name,
  title,
  avatarUrl,
  bio,
  company,
}: SpeakerInfoChyronProps) => {
  return (
    <Chyron
      size={ChyronSize.Dynamic}
      kickerPosition="top"
      kicker={intl.formatMessage({ defaultMessage: 'Speaker' })}
    >
      <div className="speaker-info-chyron">
        {avatarUrl && (
          <div className="picture">
            <img src={avatarUrl} alt="" />
          </div>
        )}
        <div className="speaker-info">
          <div className="name-title-enclosure">
            <span className="name">{name}</span>
            {(title || company) && (
              <span className="title">
                {title && company ? (
                  <FormattedMessage
                    defaultMessage="{title}, {company}"
                    values={{ title, company }}
                    description='example: "Engineer, TwentyThree"'
                  />
                ) : (
                  // eslint-disable-next-line formatjs/no-literal-string-in-jsx
                  `${title}${company}`
                )}
              </span>
            )}
          </div>
          {bio && <span className="bio dynamic-section">{bio}</span>}
        </div>
      </div>
    </Chyron>
  )
}

export default SpeakerInfoChyron
